import { Component, ElementRef, OnInit, Renderer2, NgZone } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { StoreDataServiceService } from './store-data-service.service';
import { ActivatedRoute } from '@angular/router';
import { AngularFireRemoteConfig } from '@angular/fire/compat/remote-config';
import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';
import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';
import {
  RemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";
import { ConstantService } from './service/constant.service';
import { EncryptionService } from './service/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,

    //navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      760: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
    nav: false
  };
  IpAddress = '';
  themes: string = '';
  returnUrl: string = '';
  isChecked: boolean = true;
  title = '5P_Insta_Rewards';
  showLoader = false;
  patterns = [
    '/SignOn/Auth',
    // '/Home/ClientCookieAuth',
    '/vlogin-page',
    '/login-customersupport',
    '/error',
    '/lwp',
    '/dealer'
  ];
  myCurrentURL: string = '';
  patternRedirectionURL: string = '';
  domainUrl: string;
  hostOrigin: string;
  pathname: string;
  queryParams: string;

  //public IpAddress : any;
  constructor(
    private storeDataServiceService: StoreDataServiceService,
    private renderer: Renderer2,
    private el: ElementRef,
    private activatedRouter: ActivatedRoute,
    private remoteConfig: AngularFireRemoteConfig,
    public constantService: ConstantService,
    private utilService: UtilService,
    private encryptionService: EncryptionService,
    private zone: NgZone,
    private toastr: ToastrService,
    private cookieService: CookieService,
  ) {
    this.determineTheme();
  }

  applyTheme(theme: string) {
  if (theme === 'dark') {
    this.renderer.addClass(document.body, 'dark-mode');
  } else {
    this.renderer.removeClass(document.body, 'dark-mode');
  }
}
  // determines the theme 
  determineTheme() {
  if (this.cookieService.check("theme")) {
    this.themes = this.cookieService.get("theme");


  } else {
    let storedTheme = this.storeDataServiceService.getUser_Themes();
    if (storedTheme !== undefined) {
      this.themes = storedTheme;
    } else {
      this.themes = this.detectSystemTheme(); // Default to system theme
    }
  }
  this.isChecked = this.themes === 'dark'; 
  this.storeDataServiceService.setUser_Themes(this.themes);
  this.applyTheme(this.themes); // Apply the theme without toggling
}

toggleDarkMode() {
  this.themes = this.themes === 'dark' ? 'light' : 'dark'; // Toggle the theme
  this.storeDataServiceService.setUser_Themes(this.themes);
  this.applyTheme(this.themes); // Apply the updated theme
  this.isChecked = this.themes === 'dark'; 
}
  // detects the system theme if no theme is set
detectSystemTheme(): string {
    try {

      let value=window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      return value
    } catch (e) {

      return 'light';
    }
  }

  async ngOnInit(): Promise<void> {
    this.showLoader = true;
    this.initializeFireBaseAppAndRemoteConfig().then(() => {

    }).finally(() => {
    });
    this.storeDataServiceService.fetchData()
      .then((result) => {
        this.IpAddress = result;
        this.storeDataServiceService.setIpAddress(this.IpAddress);
      }).finally(() => {
        this.showLoader = false;
      })
      .catch((error) => {
        this.showLoader = false;
        console.log('error', error)

      });


  }

  // toggles the theme of login page
 
  isChangedtheme(): void {
    this.storeDataServiceService.defafulThemeChange('Y');
    this.toggleDarkMode();
  }
  initializeFireBaseAppAndRemoteConfig = async () => {
    try {

      const app = initializeApp(environment.firebase);
      const remoteConfig: RemoteConfig = getRemoteConfig(app);
      remoteConfig.settings.minimumFetchIntervalMillis = 60000;


      await fetchAndActivate(remoteConfig);
      const frontend_crossSell_keys = getValue(remoteConfig, "frontend_crossSell_keys").asString();
      const web_tradestation_url = getValue(remoteConfig, "web_tradestation_url").asString();
      let remoteConfigData, webremoteConfigData;
      try {
        remoteConfigData = JSON.parse(frontend_crossSell_keys);
        webremoteConfigData = JSON.parse(web_tradestation_url);
        this.storeDataServiceService.setFirebasePopupConfigration(remoteConfigData.isPopupEnabled); // this value in global service
        this.storeDataServiceService.setDelayApiResponseTimer(remoteConfigData.APIDelayValue); // this value in global service
        this.storeDataServiceService.setApiTimeoutFirebaseConfigration(remoteConfigData.APITimeoutValue);
        this.myCurrentURL = remoteConfigData.myCurrentURL.toLowerCase();
        this.patternRedirectionURL = remoteConfigData.patternRedirectionURL.toLowerCase();
        this.storeDataServiceService.setCaptchaEnabled(remoteConfigData.isCaptchaEnabled); //isCaptchaEnabledPreProd
        this.storeDataServiceService.setNeedtoCallTradestationBetaApi(remoteConfigData.tradestationRedirectionThroughAPI); // 'Y'
        this.storeDataServiceService.setTradestationRedirectionValue(remoteConfigData.tradestationRedirectionValue); // 'OT & NT'
        this.storeDataServiceService.setdefaultTradestationUrl(webremoteConfigData.url);
        this.storeDataServiceService.setdefaultNewTradestationUrl(webremoteConfigData.newUrl);
        this.storeDataServiceService.setSwarajauthSecretKey(remoteConfigData.swarajauthProductionSecretKey);
        this.storeDataServiceService.setAllowDomainList(remoteConfigData.allowDormantUserForDomain);
        this.storeDataServiceService.setAspxAuthAPI(remoteConfigData.isToCallAspxauthAPI);
      } catch (error) {
        console.error("Error parsing remote config data", error);
        this.setDefaultConfig();
      }

    } catch (err) {
      console.error("Error initializing Firebase", err);
      this.setDefaultConfig();
    } finally {

    }
  };


  

  setDefaultConfig() {
    this.storeDataServiceService.setFirebasePopupConfigration(true); // if error then set default value true
    this.myCurrentURL = 'https://login.5paisa.com';
    this.patternRedirectionURL = 'https://login.5paisa.com';
    this.storeDataServiceService.setCaptchaEnabled('N'); // if error then set default value false
  }

  showSuccess() {
    this.toastr.error('Hello world!', 'Toastr fun!', {
      timeOut: 3000,
      closeButton: true,
      progressBar: true
    });
  }
}
